export const questions = [{
  q: 'How long is the purchased code valid?',
  a: 'The code is valid for 1 year from the date of purchase. However, don\'t wait too long because the Cryptic Killer is lurking.'
}, {
  q: 'Can we play on mobile devices, e.g., smartphones?',
  a: 'The game is designed for PCs, laptops, or tablets. The bigger your screen, the better, so we don\'t recommend playing on smartphones, although if you want a challenge, then that\'s on you!'
}, {
  q: 'If our game time runs out, will we be able to finish the game?',
  a: 'Yes, there is nothing to stop you. We know that rushing can be a bad idea, especially when solving puzzles. The timer is there to add some pressure to stop the Cryptic Killer. However, the game\'s main goal is to have fun, so there\'s no issue with the timer running out unless your pride gets hurt by it.'
}];
